const haveHomeScores = [
    { min: 0, max: 27, haveHome: true, score: 1 },
    { min: 27, max: 40, haveHome: true, score: 5 },
    { min: 40, max: 55, haveHome: true, score: 7 },
    { min: 55, max: 200, haveHome: true, score: 10 },

    { min: 0, max: 27, haveHome: false, score: 0 },
    { min: 27, max: 40, haveHome: false, score: -1 },
    { min: 40, max: 55, haveHome: false, score: -3 },
    { min: 55, max: 200, haveHome: false, score: -5 }
];

export default haveHomeScores;
